import React, { Component } from "react";

import CuentaSocio from "../../generico/CuentaSocio";
import SeleccionImportePago from './SeleccionImportePago'
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import authService from "../../../services/login/auth.service";
import TarjetaService from "../../../services/pagos/TarjetaService"
import {
  formatoSeparadorMilesReturn,
  formatoSeparadorMilesValue,
} from "../../generico/utils/FormatoInput";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

export default class TarjetaPaso2 extends Component {
  constructor(props) {
    super(props);
    this.refImporte = React.createRef();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    cuentasOrigen: [],
    datosTC: [],
    cuentaSeleccionada: undefined,
    importe: undefined,
    disabledNext: true,
  })


  componentDidMount() {

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getDatosTC() {
    return this.state.datosTC;
  }
  getDetalleTarjeta(numero) {

    var cuentas = [];
    var datos = [];
    trackPromise(
      TarjetaService.pagar(numero, "S")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          // console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {

            for (var i = 0; i < jsonData.resultadoAhorroList.length; i++) {

              cuentas.push({
                cuenta: jsonData.resultadoAhorroList[i].idAhorro,
                tipoDeCuenta: jsonData.resultadoAhorroList[i].descripcion,
                saldoActual: jsonData.resultadoAhorroList[i].saldoTotal,
                moneda: jsonData.resultadoAhorroList[i].moneda
                
              });
            }
            if (jsonData.resultadoPagoTarjeta != null)
              datos.push({
                descripcion: jsonData.resultadoPagoTarjeta[0].descripcion,
                moneda: jsonData.resultadoPagoTarjeta[0].moneda,
                nroTarjeta: jsonData.resultadoPagoTarjeta[0].nroTarjeta,
                pagoMinimo: jsonData.resultadoPagoTarjeta[0].pagoMinimo,
                saldoAyer: jsonData.resultadoPagoTarjeta[0].saldoAyer,
                saldoCierre: jsonData.resultadoPagoTarjeta[0].saldoCierre
              });
            this.setState({ cuentasOrigen: cuentas, datosTC: datos });

          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
            return;
          }
        }
        ).catch(function (error) {
          authService.logout()
          //console.log(error)
        }));



    return this.state.cuentasOrigen;
  }


  selectorValue = (ctaFullData, item) => {

    if (item.length === 0) {

      this.setState({ cuentaSeleccionada: item, disabledNext: true });
      return;
    }
    if (this.state.importe !== undefined)
      this.setState({ cuentaSeleccionada: item, disabledNext: false });
    else
      this.setState({ cuentaSeleccionada: item, disabledNext: true });
    this.props.rptPaso2Cuenta(item)


  };

  rptRespuesta = (respuesta) => {
    if (respuesta === "" || respuesta === "0") {
      this.setState({ importe: undefined, disabledNext: true });

      return
    }
    var importeFormateado = String(respuesta).replace(/\./g, "");
    importeFormateado = importeFormateado.replace(/\,/g, "");
    //importeFormateado = new Intl.NumberFormat("de-DE").format(parseFloat(importeFormateado));
    importeFormateado = formatoSeparadorMilesValue(importeFormateado);

    if (this.state.cuentaSeleccionada !== undefined)
      this.setState({ importe: importeFormateado, disabledNext: false });
    else
      this.setState({ importe: importeFormateado, disabledNext: true });
    this.props.rptPaso2Importe(importeFormateado)
    this.props.rptPaso2Moneda(this.state.datosTC[0].moneda)
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Tarjeta
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Datos de Pago
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row detalle-tarjeta">
          <div className="col-md-5" style={{paddingLeft: 15}}>
            <div className="row" style={{paddingTop: 15, paddingLeft: 5}}>
              <div className="col-md-12" style={{fontWeight: 500}}>
                <span className="dato" style={{fontWeight: 500, fontSize: 20}}>{this.props.tipo} {this.props.tarjeta}</span>
              </div>
              <div className="col-md-12">
                <span className="dato">Línea: {this.props.linea}</span>
              </div>
              <div className="col-md-12">
                <span className="dato">Saldo Normal: {this.props.saldoNormal}</span>
              </div>
            </div> 
          </div>
          <div className="col-md-7 tarjeta-detalle" style={{padding:15}}>
            <div className="row">
              <div className="col-6">
                <div className="titulo" style={{fontSize: 13}}>Días de Mora</div>
                <div className="dato" style={{marginTop: -5, fontWeight:500}}>{this.props.diasMora}</div>
              </div>
              <div className="col-6">
                <div className="titulo" style={{fontSize: 13}}>Saldo de Mora</div>
                <div className="dato" style={{marginTop: -5, fontWeight:500}}>{this.props.saldoMora}</div>
              </div>
              <div className="col-6">
                <div className="titulo" style={{fontSize: 13}}>Saldo del Plan</div>
                <div className="dato" style={{marginTop: -5, fontWeight:500}}>{this.props.saldoPlan}</div>
              </div>
            </div>  
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-5">
                <CuentaSocio
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  monto={this.state.monto}
                  itemSelected={this.state.itemSelected}
                  selectorValue={this.selectorValue.bind(this)}
                  isClearable
                  noOptionsMessage={() => 'SIN DATOS'}
                />
              </div>
              
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <SeleccionImportePago ref={this.refImporte} datos={this.state.datosTC} rptRespuesta={this.rptRespuesta.bind(this)} saldoMora={this.props.saldoMora}/>
          </div>
        </div>
        <hr />

        <div className="row">
          <div className="col-lg-8 col-md-6">
              <label
                className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                      <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-3 btn-consulta">
              <button className="btn btn-cu-quintary"
                onClick={this.props.previousStep}>
               <FontAwesomeIcon icon={faArrowLeft} /> Volver
                    </button>
              

          </div>
          <div className="col-lg-2 col-md-3">
          <button
                disabled={this.state.disabledNext}
                className="btn btn-cu-primary"
                onClick={this.props.paso2Next}>
                Continuar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
          </div>
        </div>

      </div>
    );
  }
}